// Sugalarm — Web Push API wrappers (cycle 17).

import { request } from "../lib/apiClient";
import type {
  ApiResult,
  PushSubscription,
  PushSubscriptionListResponse,
  PushTestResponse,
  PushVapidResponse,
} from "../lib/types";

export interface PushSubscribeBody {
  endpoint: string;
  keys: { p256dh: string; auth: string };
  user_agent?: string | null;
  device_id?: string | null;
}

export function getVapid(): Promise<ApiResult<PushVapidResponse>> {
  return request<PushVapidResponse>("/api/push/vapid", { noAuth: true });
}

export function listSubscriptions(): Promise<
  ApiResult<PushSubscriptionListResponse>
> {
  return request<PushSubscriptionListResponse>("/api/push/subscriptions");
}

export function subscribe(
  body: PushSubscribeBody,
): Promise<ApiResult<PushSubscription>> {
  return request<PushSubscription>("/api/push/subscriptions", {
    method: "POST",
    body,
  });
}

export function unsubscribe(id: string): Promise<ApiResult<void>> {
  return request<void>(`/api/push/subscriptions/${id}`, {
    method: "DELETE",
  });
}

export function sendTest(): Promise<ApiResult<PushTestResponse>> {
  return request<PushTestResponse>("/api/push/test", { method: "POST" });
}
